export const TASK_DATA_TYPE_NAMES = {
  taskListAbsenceData: 'TaskListAbsenceData',
  absenceData: 'AbsenceData',
  monthlySheetData: 'MonthlySheetData',
} as const
